export default __webpack_public_path__ + "media/images/awesome-long-arrow-alt-left-52a24fe1f0393c6b6179676da8551458.svg";